import {
  IsNotEmpty,
  IsInt,
  IsArray,
  IsOptional,
  ValidateNested,
  ArrayUnique,
  IsEnum,
} from "class-validator";
import { Type } from "class-transformer";

import { SiteLicenseDto } from "./site-license.dto";
import { Constants } from "@river/constants";

export class LicenseDto {
  _id?: string;

  @IsNotEmpty()
  @IsEnum(Constants.license_type)
  license: string;

  @IsNotEmpty()
  description: string;

  @IsNotEmpty()
  @IsInt()
  count: number;

  @IsOptional()
  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => SiteLicenseDto)
  @ArrayUnique((siteLicense) => siteLicense.site) // cannot have one site multiple times
  sites?: SiteLicenseDto[];
}
